import React, { useState } from "react";
import "./EasyBuySummaryMobileView.css";
import { useTranslation } from "react-i18next";
import SvgEncircledMinus from "../../../../../components/SvgContainer/SvgIcons/SvgEncircledMinus";
import SvgEncircledPlus from "../../../../../components/SvgContainer/SvgIcons/SvgEncircledPlus";
import EasyBuySummaryDetails from "./EasyBuySummaryDetails";

const EasyBuySummaryMobileView = ({ isApplyBPlusNewDeviceDiscount = false, easyBuySummaryData, setEasyBuySummaryData }) => {

  const { t } = useTranslation();
  const [showSummary, setShowSummary] = useState(false);

  return (
    <div className="easybuy-summary-container-mobile">
      <div className="easybuy-summary-title-container">
        <h3 className="summary-title">{t("EASY_BUY_SUMMARY.TITLE")}</h3>
        {showSummary && <span className="encirlcedIcon" onClick={() => setShowSummary(!showSummary)}><SvgEncircledMinus width={24} height={24}></SvgEncircledMinus></span>}
        {!showSummary && <span className="encirlcedIcon" onClick={() => setShowSummary(!showSummary)}><SvgEncircledPlus width={24} height={24}></SvgEncircledPlus></span>}
      </div>
      {showSummary && <EasyBuySummaryDetails isApplyBPlusNewDeviceDiscount={isApplyBPlusNewDeviceDiscount} easyBuySummaryData={easyBuySummaryData} setEasyBuySummaryData={setEasyBuySummaryData}></EasyBuySummaryDetails>}
    </div>
  );
};

export default EasyBuySummaryMobileView;
